// 纯国际化逻辑（无 React / antd 依赖），供请求层与 UI 层共用
// 语言码：默认中文，支持的语言见 SUPPORTED_LANGS
export const DEFAULT_LANG = 'zh';

// URL 查询参数 lang 的语言码 -> 内部语言码映射（顺序与后端 LanguageEnum 一致，0=zh 对应中文）
const LANG_CODE_MAP = {
  'zh': 'zh',
  'en': 'en',
  'spa': 'es',
  'cht': 'zh-TW',
  'fr': 'fr',
  'jp': 'ja',
  'kor': 'ko',
  'hu': 'hu',
  'pt': 'pt',
  'de': 'de',
};

export const SUPPORTED_LANGS = ['zh', 'en', 'es', 'fr', 'ja', 'hu', 'ko', 'pt', 'de', 'zh-TW'];

// 翻译字典：key 为中文原文，值根据语言返回
const MESSAGES = {
  // 页签
  '换锅申请': {
    en: 'Pot Change Application',
    es: 'Solicitud de cambio de olla',
    fr: 'Demande de changement de marmite',
    ja: '鍋交換の申請',
    hu: 'Edénycsere kérelem',
    ko: '냄비 교체 신청',
    pt: 'Solicitação de troca de panela',
    de: 'Topfwechsel-Antrag',
    'zh-TW': '換鍋申請',
  },
  '换锅记录': {
    en: 'Pot Change Records',
    es: 'Historial de cambios de olla',
    fr: 'Historique des changements',
    ja: '鍋交換の履歴',
    hu: 'Edénycsere előzmények',
    ko: '냄비 교체 기록',
    pt: 'Histórico de trocas de panela',
    de: 'Topfwechsel-Verlauf',
    'zh-TW': '換鍋記錄',
  },

  // 教程视频标题
  '换锅教程': {
    en: 'Pot Change Tutorial',
    es: 'Tutorial de cambio de olla',
    fr: 'Tutoriel de changement de marmite',
    ja: '鍋交換チュートリアル',
    hu: 'Edénycsere útmutató',
    ko: '냄비 교체 튜토리얼',
    pt: 'Tutorial de troca de panela',
    de: 'Topfwechsel-Anleitung',
    'zh-TW': '換鍋教程',
  },
  'XA460涂层锅更换': {
    en: 'XA460 Coated Wok Replacement',
    es: 'Reemplazo de wok recubierto XA460',
    fr: 'Remplacement du wok revêtu XA460',
    ja: 'XA460 コーティング鍋交換',
    hu: 'XA460 bevonatos wok csere',
    ko: 'XA460 코팅 웍 교체',
    pt: 'Substituição do wok revestido XA460',
    de: 'XA460 beschichteter Wok Austausch',
    'zh-TW': 'XA460塗層鍋更換',
  },
  'XA460E涂层锅更换': {
    en: 'XA460E Coated Wok Replacement',
    es: 'Reemplazo de wok recubierto XA460E',
    fr: 'Remplacement du wok revêtu XA460E',
    ja: 'XA460E コーティング鍋交換',
    hu: 'XA460E bevonatos wok csere',
    ko: 'XA460E 코팅 웍 교체',
    pt: 'Substituição do wok revestido XA460E',
    de: 'XA460E beschichteter Wok Austausch',
    'zh-TW': 'XA460E塗層鍋更換',
  },

  // 历史记录状态
  '申请已提交': {
    en: 'Application submitted',
    es: 'Solicitud enviada',
    fr: 'Demande envoyée',
    ja: '申請済み',
    hu: 'Kérelem elküldve',
    ko: '신청 제출됨',
    pt: 'Solicitação enviada',
    de: 'Antrag eingereicht',
    'zh-TW': '申請已提交',
  },
  '旧锅已发出': {
    en: 'Old pot shipped',
    es: 'Olla usada enviada',
    fr: 'Ancienne marmite expédiée',
    ja: '旧鍋を発送済み',
    hu: 'Régi edény feladva',
    ko: '기존 냄비 발송됨',
    pt: 'Panela antiga enviada',
    de: 'Alter Topf versandt',
    'zh-TW': '舊鍋已發出',
  },
  '旧锅已收到': {
    en: 'Old pot received',
    es: 'Olla usada recibida',
    fr: 'Ancienne marmite reçue',
    ja: '旧鍋を受領済み',
    hu: 'Régi edény beérkezett',
    ko: '기존 냄비 수령됨',
    pt: 'Panela antiga recebida',
    de: 'Alter Topf erhalten',
    'zh-TW': '舊鍋已收到',
  },
  '仓库已确认': {
    en: 'Warehouse confirmed',
    es: 'Almacén confirmado',
    fr: 'Entrepôt confirmé',
    ja: '倉庫で確認済み',
    hu: 'Raktár visszaigazolta',
    ko: '창고 확인 완료',
    pt: 'Armazém confirmado',
    de: 'Lager bestätigt',
    'zh-TW': '倉庫已確認',
  },
  '已推单': {
    en: 'Order pushed',
    es: 'Pedido enviado',
    fr: 'Commande envoyée',
    ja: '注文送信済み',
    hu: 'Rendelés továbbítva',
    ko: '주문 전달됨',
    pt: 'Pedido encaminhado',
    de: 'Bestellung weitergeleitet',
    'zh-TW': '已推單',
  },
  '新锅待发出': {
    en: 'New pot awaiting shipment',
    es: 'Olla nueva pendiente de envío',
    fr: 'Nouvelle marmite en attente d\'expédition',
    ja: '新鍋の発送待ち',
    hu: 'Új edény kiszállításra vár',
    ko: '새 냄비 발송 대기 중',
    pt: 'Panela nova aguardando envio',
    de: 'Neuer Topf wartet auf Versand',
    'zh-TW': '新鍋待發出',
  },
  '新锅已发出': {
    en: 'New pot shipped',
    es: 'Olla nueva enviada',
    fr: 'Nouvelle marmite expédiée',
    ja: '新鍋を発送済み',
    hu: 'Új edény feladva',
    ko: '새 냄비 발송됨',
    pt: 'Panela nova enviada',
    de: 'Neuer Topf versandt',
    'zh-TW': '新鍋已發出',
  },

  // 历史记录
  '提交日期：{time}': {
    en: 'Submitted: {time}',
    es: 'Fecha de envío: {time}',
    fr: 'Date de soumission : {time}',
    ja: '提出日時：{time}',
    hu: 'Beküldés dátuma: {time}',
    ko: '제출 날짜: {time}',
    pt: 'Data de envio: {time}',
    de: 'Eingereicht am: {time}',
    'zh-TW': '提交日期：{time}',
  },
  '旧锅快递单号：': {
    en: 'Old pot tracking No.: ',
    es: 'Nº de seguimiento de la olla usada: ',
    fr: 'Nº de suivi ancienne marmite : ',
    ja: '旧鍋の配送伝票番号：',
    hu: 'Régi edény csomagszáma: ',
    ko: '기존 냄비 운송장 번호: ',
    pt: 'Nº de rastreio da panela antiga: ',
    de: 'Sendungsnr. alter Topf: ',
    'zh-TW': '舊鍋快遞單號：',
  },
  '新锅快递单号：': {
    en: 'New pot tracking No.: ',
    es: 'Nº de seguimiento de la olla nueva: ',
    fr: 'Nº de suivi nouvelle marmite : ',
    ja: '新鍋の配送伝票番号：',
    hu: 'Új edény csomagszáma: ',
    ko: '새 냄비 운송장 번호: ',
    pt: 'Nº de rastreio da panela nova: ',
    de: 'Sendungsnr. neuer Topf: ',
    'zh-TW': '新鍋快遞單號：',
  },
  '无': {
    en: 'None',
    es: 'Ninguno',
    fr: 'Aucun',
    ja: 'なし',
    hu: 'Nincs',
    ko: '없음',
    pt: 'Nenhum',
    de: 'Keine',
    'zh-TW': '無',
  },
  '状态：': {
    en: 'Status: ',
    es: 'Estado: ',
    fr: 'Statut : ',
    ja: 'ステータス：',
    hu: 'Állapot: ',
    ko: '상태: ',
    pt: 'Status: ',
    de: 'Status: ',
    'zh-TW': '狀態：',
  },
  '删除': {
    en: 'Delete',
    es: 'Eliminar',
    fr: 'Supprimer',
    ja: '削除',
    hu: 'Törlés',
    ko: '삭제',
    pt: 'Excluir',
    de: 'Löschen',
    'zh-TW': '刪除',
  },
  '确认要删除吗？': {
    en: 'Are you sure you want to delete?',
    es: '¿Seguro que desea eliminarlo?',
    fr: 'Voulez-vous vraiment supprimer ?',
    ja: '削除してもよろしいですか？',
    hu: 'Biztosan törölni szeretné?',
    ko: '정말 삭제하시겠습니까?',
    pt: 'Tem certeza de que deseja excluir?',
    de: 'Möchten Sie wirklich löschen?',
    'zh-TW': '確定要刪除嗎？',
  },
  '删除成功': {
    en: 'Deleted successfully',
    es: 'Eliminado correctamente',
    fr: 'Supprimé avec succès',
    ja: '削除しました',
    hu: 'Sikeresen törölve',
    ko: '삭제되었습니다',
    pt: 'Excluído com sucesso',
    de: 'Erfolgreich gelöscht',
    'zh-TW': '刪除成功',
  },
  '复制成功': {
    en: 'Copied',
    es: 'Copiado',
    fr: 'Copié',
    ja: 'コピーしました',
    hu: 'Másolva',
    ko: '복사됨',
    pt: 'Copiado',
    de: 'Kopiert',
    'zh-TW': '複製成功',
  },

  // 换锅申请页
  '换锅完成后请将换下的旧锅装回原包装（双层纸箱）': {
    en: 'After replacing the pot, put the old pot back into its original packaging (double-layer carton)',
    es: 'Tras el cambio, guarde la olla usada en su embalaje original (caja de doble capa)',
    fr: 'Après le remplacement, remettez l\'ancienne marmite dans son emballage d\'origine (carton double couche)',
    ja: '交換後、取り外した旧鍋を元の梱包（二重段ボール）に戻してください',
    hu: 'Csere után csomagolja vissza a régi edényt az eredeti (kétrétegű) dobozába',
    ko: '교체 후 사용한 냄비를 원래 포장(이중 상자)에 다시 넣어주세요',
    pt: 'Após a troca, coloque a panela antiga na embalagem original (caixa de camada dupla)',
    de: 'Verpacken Sie den alten Topf nach dem Wechsel wieder in der Originalverpackung (doppelwandiger Karton)',
    'zh-TW': '換鍋完成後請將換下的舊鍋裝回原包裝（雙層紙箱）',
  },
  '等待快递员上门取件': {
    en: 'Wait for courier pickup',
    es: 'Espere la recogida del mensajero',
    fr: 'Attendre le passage du livreur',
    ja: '宅配業者の集荷を待つ',
    hu: 'Várjon a futárra',
    ko: '택배 기사 방문 수거 대기',
    pt: 'Aguarde a coleta do entregador',
    de: 'Auf Abholung durch den Kurier warten',
    'zh-TW': '等待快遞員上門取件',
  },
  '自行前往快递站点邮寄': {
    en: 'Drop off at a courier station yourself',
    es: 'Llévelo usted mismo a un punto de envío',
    fr: 'Déposez vous-même le colis dans un point relais',
    ja: 'ご自身で宅配の受付窓口へ持ち込む',
    hu: 'Saját maga adja fel egy csomagponton',
    ko: '직접 택배 접수처에 방문하여 발송',
    pt: 'Leve você mesmo a um ponto de envio',
    de: 'Selbst bei einer Versandstelle abgeben',
    'zh-TW': '自行前往快遞站點郵寄',
  },
  '上门取件': {
    en: 'Courier pickup',
    es: 'Recogida a domicilio',
    fr: 'Collecte à domicile',
    ja: '集荷',
    hu: 'Futáros átvétel',
    ko: '방문 수거',
    pt: 'Coleta em domicílio',
    de: 'Abholung',
    'zh-TW': '上門取件',
  },
  '自行寄回': {
    en: 'Return it yourself',
    es: 'Devolver por su cuenta',
    fr: 'Renvoyer soi-même',
    ja: '自己返送',
    hu: 'Önálló visszaküldés',
    ko: '직접 반송',
    pt: 'Devolver por conta própria',
    de: 'Selbst zurücksenden',
    'zh-TW': '自行寄回',
  },
  '默认是顺丰，可以选择其他快递，运费自付呦': {
    en: 'SF Express is selected by default. You can choose another courier; shipping cost is at your own expense.',
    es: 'SF Express está seleccionado por defecto. Puede elegir otro servicio de mensajería; el envío corre por su cuenta.',
    fr: 'SF Express est sélectionné par défaut. Vous pouvez choisir un autre transporteur ; les frais d\'envoi sont à votre charge.',
    ja: '初期設定は順豊（SF）です。他の宅配業者も選択でき、送料は自己負担です。',
    hu: 'Alapértelmezés szerint az SF Express van kiválasztva. Más futárszolgálatot is választhat; a szállítási költség az Önt terheli.',
    ko: '기본은 SF Express입니다. 다른 택배사를 선택할 수 있으며 운임은 본인 부담입니다.',
    pt: 'SF Express está selecionado por padrão. Você pode escolher outra transportadora; o frete é por sua conta.',
    de: 'SF Express ist standardmäßig ausgewählt. Sie können einen anderen Kurierdienst wählen; die Versandkosten tragen Sie selbst.',
    'zh-TW': '預設是順豐，可以選擇其他快遞，運費自付呦',
  },
  '顺丰': {
    en: 'SF Express',
    es: 'SF Express',
    fr: 'SF Express',
    ja: '順豊（SF）',
    hu: 'SF Express',
    ko: 'SF 익스프레스',
    pt: 'SF Express',
    de: 'SF Express',
    'zh-TW': '順豐',
  },
  '中通': {
    en: 'ZTO Express',
    es: 'ZTO Express',
    fr: 'ZTO Express',
    ja: '中通（ZTO）',
    hu: 'ZTO Express',
    ko: 'ZTO 익스프레스',
    pt: 'ZTO Express',
    de: 'ZTO Express',
    'zh-TW': '中通',
  },
  '您有换锅申请正在进行中，如果需要修改相关信息，请在下方修改': {
    en: 'You have a pot change application in progress. If you need to modify the information, please do so below.',
    es: 'Tiene una solicitud de cambio en curso. Si necesita modificar la información, hágalo a continuación.',
    fr: 'Vous avez une demande de changement en cours. Si vous devez modifier les informations, faites-le ci-dessous.',
    ja: '鍋交換の申請が進行中です。情報を変更する場合は、下記で修正してください。',
    hu: 'Folyamatban lévő edénycsere-kérelem van. Ha módosítani szeretné az adatokat, tegye meg lent.',
    ko: '진행 중인 냄비 교체 신청이 있습니다. 정보를 수정하려면 아래에서 수정하세요.',
    pt: 'Você tem uma solicitação de troca em andamento. Se precisar modificar as informações, faça-o abaixo.',
    de: 'Sie haben einen laufenden Topfwechsel-Antrag. Wenn Sie die Angaben ändern möchten, tun Sie dies unten.',
    'zh-TW': '您有換鍋申請正在進行中，如果需要修改相關資訊，請在下方修改',
  },
  '旧锅收件地址： ': {
    en: 'Old pot delivery address: ',
    es: 'Dirección de entrega de la olla usada: ',
    fr: 'Adresse de réception de l\'ancienne marmite : ',
    ja: '旧鍋の受取住所：',
    hu: 'Régi edény átvételi címe: ',
    ko: '기존 냄비 수령 주소: ',
    pt: 'Endereço de recebimento da panela antiga: ',
    de: 'Lieferadresse alter Topf: ',
    'zh-TW': '舊鍋收件地址：',
  },
  '已复制旧锅收件地址': {
    en: 'Old pot delivery address copied',
    es: 'Dirección de la olla usada copiada',
    fr: 'Adresse de l\'ancienne marmite copiée',
    ja: '旧鍋の受取住所をコピーしました',
    hu: 'Régi edény átvételi címe másolva',
    ko: '기존 냄비 수령 주소가 복사되었습니다',
    pt: 'Endereço da panela antiga copiado',
    de: 'Lieferadresse des alten Topfes kopiert',
    'zh-TW': '已複製舊鍋收件地址',
  },
  '复制地址': {
    en: 'Copy address',
    es: 'Copiar dirección',
    fr: 'Copier l\'adresse',
    ja: '住所をコピー',
    hu: 'Cím másolása',
    ko: '주소 복사',
    pt: 'Copiar endereço',
    de: 'Adresse kopieren',
    'zh-TW': '複製地址',
  },
  '快递单号': {
    en: 'Tracking No.',
    es: 'Nº de seguimiento',
    fr: 'Nº de suivi',
    ja: '配送伝票番号',
    hu: 'Csomagszám',
    ko: '운송장 번호',
    pt: 'Nº de rastreio',
    de: 'Sendungsnummer',
    'zh-TW': '快遞單號',
  },
  '请输入旧锅快递单号': {
    en: 'Enter old pot tracking number',
    es: 'Introduzca el nº de seguimiento de la olla usada',
    fr: 'Saisissez le nº de suivi de l\'ancienne marmite',
    ja: '旧鍋の配送伝票番号を入力',
    hu: 'Adja meg a régi edény csomagszámát',
    ko: '기존 냄비 운송장 번호를 입력하세요',
    pt: 'Digite o nº de rastreio da panela antiga',
    de: 'Sendungsnummer des alten Topfes eingeben',
    'zh-TW': '請輸入舊鍋快遞單號',
  },
  '本锅一共烹饪': {
    en: 'This pot has been used ',
    es: 'Esta olla se ha usado ',
    fr: 'Cette marmite a été utilisée ',
    ja: 'この鍋は',
    hu: 'Ez az edény ',
    ko: '이 냄비는 ',
    pt: 'Esta panela foi usada ',
    de: 'Dieser Topf wurde ',
    'zh-TW': '本鍋一共烹飪',
  },
  '次，建议': {
    en: ' times. Replacement is recommended after ',
    es: ' veces. Se recomienda cambiarla después de ',
    fr: ' fois. Le remplacement est conseillé après ',
    ja: '回使用されています。',
    hu: ' alkalommal lett használva. Csere javasolt ',
    ko: '회 사용되었습니다. ',
    pt: ' vezes. Recomenda-se a troca após ',
    de: ' Mal verwendet. Ein Wechsel wird nach ',
    'zh-TW': '次，建議',
  },
  '次以上更换，您可以尝试手动清洗锅，看是否粘锅': {
    en: ' uses. You can try cleaning the pot manually to see if food sticks.',
    es: ' usos. Puede intentar limpiarla manualmente para ver si se pega.',
    fr: ' utilisations. Essayez de la nettoyer manuellement pour vérifier si les aliments collent.',
    ja: '回以上での交換を推奨します。手動で洗浄して焦げ付きを確認してください。',
    hu: ' használat után javasolt. Próbálja kézzel megtisztítani, hogy megnézze, leragad-e.',
    ko: '회 이상 사용 시 교체를 권장합니다. 수동으로 세척하여 눌어붙는지 확인해 보세요.',
    pt: ' usos. Você pode tentar limpá-la manualmente para ver se gruda.',
    de: ' Verwendungen empfohlen. Sie können den Topf manuell reinigen, um zu prüfen, ob Speisen ankleben.',
    'zh-TW': '次以上更換，您可以嘗試手動清洗鍋，看是否粘鍋',
  },
  '次': {
    en: ' times in total',
    es: ' veces en total',
    fr: ' fois au total',
    ja: '回使用されています',
    hu: ' alkalommal lett használva',
    ko: '회 사용되었습니다',
    pt: ' vezes no total',
    de: ' Mal verwendet',
    'zh-TW': '次',
  },
  '机器名称': {
    en: 'Machine name',
    es: 'Nombre de la máquina',
    fr: 'Nom de la machine',
    ja: '機器名',
    hu: 'Gép neve',
    ko: '기기 이름',
    pt: 'Nome da máquina',
    de: 'Maschinenname',
    'zh-TW': '機器名稱',
  },
  '新锅收件地址': {
    en: 'New pot delivery address',
    es: 'Dirección de entrega de la olla nueva',
    fr: 'Adresse de livraison de la nouvelle marmite',
    ja: '新鍋の受取住所',
    hu: 'Új edény szállítási címe',
    ko: '새 냄비 수령 주소',
    pt: 'Endereço de entrega da panela nova',
    de: 'Lieferadresse neuer Topf',
    'zh-TW': '新鍋收件地址',
  },
  '请输入收件地址': {
    en: 'Enter delivery address',
    es: 'Introduzca la dirección de entrega',
    fr: 'Saisissez l\'adresse de livraison',
    ja: '受取住所を入力',
    hu: 'Adja meg a szállítási címet',
    ko: '수령 주소를 입력하세요',
    pt: 'Digite o endereço de entrega',
    de: 'Lieferadresse eingeben',
    'zh-TW': '請輸入收件地址',
  },
  '收件人': {
    en: 'Recipient',
    es: 'Destinatario',
    fr: 'Destinataire',
    ja: '受取人',
    hu: 'Átvevő',
    ko: '수령인',
    pt: 'Destinatário',
    de: 'Empfänger',
    'zh-TW': '收件人',
  },
  '请输入收件人姓名': {
    en: 'Enter recipient name',
    es: 'Introduzca el nombre del destinatario',
    fr: 'Saisissez le nom du destinataire',
    ja: '受取人の氏名を入力',
    hu: 'Adja meg az átvevő nevét',
    ko: '수령인 이름을 입력하세요',
    pt: 'Digite o nome do destinatário',
    de: 'Name des Empfängers eingeben',
    'zh-TW': '請輸入收件人姓名',
  },
  '收件人电话': {
    en: 'Recipient phone',
    es: 'Teléfono del destinatario',
    fr: 'Téléphone du destinataire',
    ja: '受取人の電話番号',
    hu: 'Átvevő telefonszáma',
    ko: '수령인 전화번호',
    pt: 'Telefone do destinatário',
    de: 'Telefonnummer des Empfängers',
    'zh-TW': '收件人電話',
  },
  '请输入收件人电话': {
    en: 'Enter recipient phone number',
    es: 'Introduzca el teléfono del destinatario',
    fr: 'Saisissez le téléphone du destinataire',
    ja: '受取人の電話番号を入力',
    hu: 'Adja meg az átvevő telefonszámát',
    ko: '수령인 전화번호를 입력하세요',
    pt: 'Digite o telefone do destinatário',
    de: 'Telefonnummer des Empfängers eingeben',
    'zh-TW': '請輸入收件人電話',
  },
  '备注/留言': {
    en: 'Remarks / Message',
    es: 'Observaciones / Mensaje',
    fr: 'Remarques / Message',
    ja: '備考・メッセージ',
    hu: 'Megjegyzés / Üzenet',
    ko: '비고/메시지',
    pt: 'Observações / Mensagem',
    de: 'Bemerkungen / Nachricht',
    'zh-TW': '備註/留言',
  },
  '请输入备注/留言': {
    en: 'Enter remarks / message',
    es: 'Introduzca observaciones / mensaje',
    fr: 'Saisissez vos remarques / message',
    ja: '備考・メッセージを入力',
    hu: 'Adja meg a megjegyzést / üzenetet',
    ko: '비고/메시지를 입력하세요',
    pt: 'Digite observações / mensagem',
    de: 'Bemerkungen / Nachricht eingeben',
    'zh-TW': '請輸入備註/留言',
  },
  '修改申请': {
    en: 'Modify Application',
    es: 'Modificar solicitud',
    fr: 'Modifier la demande',
    ja: '申請を修正',
    hu: 'Kérelem módosítása',
    ko: '신청 수정',
    pt: 'Modificar solicitação',
    de: 'Antrag ändern',
    'zh-TW': '修改申請',
  },
  '提交申请': {
    en: 'Submit Application',
    es: 'Enviar solicitud',
    fr: 'Envoyer la demande',
    ja: '申請を送信',
    hu: 'Kérelem elküldése',
    ko: '신청 제출',
    pt: 'Enviar solicitação',
    de: 'Antrag einreichen',
    'zh-TW': '提交申請',
  },

  // 校验提示
  '新锅收件地址不能为空': {
    en: 'New pot delivery address cannot be empty',
    es: 'La dirección de entrega de la olla nueva no puede estar vacía',
    fr: 'L\'adresse de livraison de la nouvelle marmite ne peut pas être vide',
    ja: '新鍋の受取住所は必須です',
    hu: 'Az új edény szállítási címe nem lehet üres',
    ko: '새 냄비 수령 주소는 비워둘 수 없습니다',
    pt: 'O endereço de entrega da panela nova não pode estar vazio',
    de: 'Die Lieferadresse des neuen Topfes darf nicht leer sein',
    'zh-TW': '新鍋收件地址不能為空',
  },
  '收件人电话不能为空': {
    en: 'Recipient phone cannot be empty',
    es: 'El teléfono del destinatario no puede estar vacío',
    fr: 'Le téléphone du destinataire ne peut pas être vide',
    ja: '受取人の電話番号は必須です',
    hu: 'Az átvevő telefonszáma nem lehet üres',
    ko: '수령인 전화번호는 비워둘 수 없습니다',
    pt: 'O telefone do destinatário não pode estar vazio',
    de: 'Die Telefonnummer des Empfängers darf nicht leer sein',
    'zh-TW': '收件人電話不能為空',
  },
  '收件人电话格式不正确': {
    en: 'Recipient phone number format is invalid',
    es: 'El formato del teléfono del destinatario no es válido',
    fr: 'Le format du téléphone du destinataire est invalide',
    ja: '受取人の電話番号の形式が正しくありません',
    hu: 'Az átvevő telefonszámának formátuma érvénytelen',
    ko: '수령인 전화번호 형식이 올바르지 않습니다',
    pt: 'O formato do telefone do destinatário é inválido',
    de: 'Das Format der Telefonnummer des Empfängers ist ungültig',
    'zh-TW': '收件人電話格式不正確',
  },
  '收件人不能为空': {
    en: 'Recipient cannot be empty',
    es: 'El destinatario no puede estar vacío',
    fr: 'Le destinataire ne peut pas être vide',
    ja: '受取人は必須です',
    hu: 'Az átvevő nem lehet üres',
    ko: '수령인은 비워둘 수 없습니다',
    pt: 'O destinatário não pode estar vazio',
    de: 'Der Empfänger darf nicht leer sein',
    'zh-TW': '收件人不能為空',
  },
  '换锅申请已修改': {
    en: 'Pot change application updated',
    es: 'Solicitud de cambio actualizada',
    fr: 'Demande de changement modifiée',
    ja: '鍋交換の申請を更新しました',
    hu: 'Az edénycsere-kérelem módosítva',
    ko: '냄비 교체 신청이 수정되었습니다',
    pt: 'Solicitação de troca atualizada',
    de: 'Topfwechsel-Antrag geändert',
    'zh-TW': '換鍋申請已修改',
  },
  '换锅申请已提交': {
    en: 'Pot change application submitted',
    es: 'Solicitud de cambio enviada',
    fr: 'Demande de changement envoyée',
    ja: '鍋交換の申請を送信しました',
    hu: 'Az edénycsere-kérelem elküldve',
    ko: '냄비 교체 신청이 제출되었습니다',
    pt: 'Solicitação de troca enviada',
    de: 'Topfwechsel-Antrag eingereicht',
    'zh-TW': '換鍋申請已提交',
  },

  // request.js 错误提示
  '无法访问服务器，请稍后再试': {
    en: 'Unable to reach the server, please try again later',
    es: 'No se pudo conectar con el servidor, inténtelo de nuevo más tarde',
    fr: 'Impossible de joindre le serveur, veuillez réessayer plus tard',
    ja: 'サーバーに接続できません。後でもう一度お試しください',
    hu: 'A szerver nem érhető el, próbálja újra később',
    ko: '서버에 연결할 수 없습니다. 잠시 후 다시 시도하세요',
    pt: 'Não foi possível acessar o servidor, tente novamente mais tarde',
    de: 'Der Server ist nicht erreichbar, bitte versuchen Sie es später erneut',
    'zh-TW': '無法訪問伺服器，請稍後再試',
  },
  '请求出错 {code}': {
    en: 'Request error {code}',
    es: 'Error de solicitud {code}',
    fr: 'Erreur de requête {code}',
    ja: 'リクエストエラー {code}',
    hu: 'Kérés hiba {code}',
    ko: '요청 오류 {code}',
    pt: 'Erro na solicitação {code}',
    de: 'Anfragefehler {code}',
    'zh-TW': '請求出錯 {code}',
  },

  // 二维码过期弹窗
  '提示': {
    en: 'Notice',
    es: 'Aviso',
    fr: 'Information',
    ja: 'お知らせ',
    hu: 'Értesítés',
    ko: '알림',
    pt: 'Aviso',
    de: 'Hinweis',
    'zh-TW': '提示',
  },
  '二维码已过期，请重新在机器上生成二维码后扫码进入': {
    en: 'The QR code has expired. Please generate a new QR code on the machine and scan it to enter.',
    es: 'El código QR ha caducado. Genere un nuevo código QR en la máquina y escanéelo para entrar.',
    fr: 'Le QR code a expiré. Veuillez générer un nouveau QR code sur la machine puis le scanner pour entrer.',
    ja: 'QRコードの有効期限が切れました。機器で新しいQRコードを生成し、再度読み取って入ってください。',
    hu: 'A QR-kód lejárt. Kérjük, generáljon új QR-kódot a gépen, majd olvassa be a belépéshez.',
    ko: 'QR 코드가 만료되었습니다. 기기에서 새 QR 코드를 생성한 후 다시 스캔하여 들어오세요.',
    pt: 'O QR code expirou. Gere um novo QR code na máquina e escaneie para entrar.',
    de: 'Der QR-Code ist abgelaufen. Bitte generieren Sie auf der Maschine einen neuen QR-Code und scannen Sie ihn zum Betreten erneut.',
    'zh-TW': 'QR碼已過期，請重新在機器上生成QR碼後掃碼進入',
  },
};

let currentLang = DEFAULT_LANG;

// 从 URL 查询参数 lang 读取语言码（zh/en/spa/cht/fr/jp/kor/hu/pt/de）；无法识别或未携带时默认中文
export function detectLanguage() {
  const query = new URLSearchParams(window.location.search);
  const langParam = query.get('lang');
  if (langParam !== null && langParam !== '') {
    const lang = LANG_CODE_MAP[langParam.toLowerCase()];
    if (lang) {
      return lang;
    }
    // lang 参数存在但无法识别，直接默认中文
    return DEFAULT_LANG;
  }
  try {
    const stored = (window.localStorage.getItem('lang') || '').toLowerCase();
    if (SUPPORTED_LANGS.indexOf(stored) >= 0) {
      return stored;
    }
  } catch (e) {
    // ignore localStorage access errors
  }
  return DEFAULT_LANG;
}

// 设置当前语言（供 Provider 初始化与手动切换时调用），返回规范化后的语言码
export function setLanguage(lang) {
  currentLang = SUPPORTED_LANGS.indexOf(lang) >= 0 ? lang : DEFAULT_LANG;
  return currentLang;
}

export function getLanguage() {
  return currentLang;
}

// 翻译函数：key 为中文原文，支持 {变量} 插值
export function t(key, vars) {
  let text = key;
  const messages = MESSAGES[key];
  if (messages && messages[currentLang]) {
    text = messages[currentLang];
  }
  if (vars) {
    Object.keys(vars).forEach(name => {
      text = text.replace(new RegExp(`\\{${name}\\}`, 'g'), () => String(vars[name]));
    });
  }
  return text;
}

export default {
  detectLanguage,
  setLanguage,
  getLanguage,
  t,
  DEFAULT_LANG,
  SUPPORTED_LANGS,
};
